import React, { useEffect, useState } from "react";
import Auth from "../../utils/AuthUtils";
import { Link } from "react-router-dom";
import webAPI from "../../api/webApi";
import RegistrationDataChart from "./charts/RegistrationDataChart";
import { useTranslation } from "react-i18next";
import Timeline from "./Timeline";

function Dashboard() {
  const { t } = useTranslation();

  const image = Auth.getUserDetails("image");

  const [dailyRegistrationData, setDailyRegistrationData] = useState([]);

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    const res = await webAPI.dashboard();

    if (res.code === 200) {
      const result = res.data;
      setDailyRegistrationData(result.dailyRegistrations);
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="row">
          <div className="col-md-12">
            <div className="page-header">
              <div className="row align-items-center ">
                <div className="col-md-4">
                  <h3 className="page-title">{t("dashboard")}</h3>
                </div>
              </div>
            </div>
          </div>
        </div>

        {Auth.getUserDetails("roles") !== "superadmin" && (
          <div className="row">
            <div className="col-md-3">
              <div className="card">
                <div className="card-body">
                  <div
                    className="card-img card-img-hover mb-3"
                    style={{ textAlign: "center" }}
                  >
                    <a href="javascript:void(0);" className="rounded">
                      <img
                        src={
                          image ||
                          `${process.env.PUBLIC_URL}/img/user-dummy.jpg`
                        }
                        className="rounded img-fluid"
                        style={{ width: "150px", objectFit: "contain" }}
                        alt="Img"
                      />
                    </a>
                  </div>
                  <h6 className="text-center fs-14">
                    <a href="javascript:void(0);">
                      {Auth.getUserDetails("name")}
                    </a>
                    <p className="fs-13 mt-1 mb-0">
                      {Auth.getUserDetails("roles")}
                    </p>
                    {Auth.getUserDetails("state") && (
                      <p className="fs-13 mt-1 mb-0">
                        {Auth.getUserDetails("state") || ""} -{" "}
                        {Auth.getUserDetails("constituency") || ""}
                      </p>
                    )}
                  </h6>
                  {/* <div className="mt-3">
                    <Link
                      to="/admin/registrations"
                      className="btn btn-outline-primary text-primary w-100"
                    >
                      ({t("view_participants")}){" "}
                      <i className="ti ti-arrow-right ms-2" />
                    </Link>
                  </div> */}
                </div>
              </div>
            </div>

            <div className="col-md-3 mainbox">
              <div className="card card-body">
                <div className="card-icon">
                  <img
                    src={`${process.env.PUBLIC_URL}/img/file-manager/sop.webp`}
                    style={{ width: "150px" }}
                  />
                </div>
                <h5 className="card-title mb-2">{t("sop_guidelines")}</h5>
                <p className="card-text" style={{ height: "60px" }}>
                  {t("sop_guidelines_description")}
                </p>
                <Link
                  to="/admin/sop-guide"
                  className="btn btn-primary btn-blink"
                >
                  {t("open_guidelines")}
                </Link>
              </div>
            </div>

            <div className="col-md-3 mainbox">
              <div className="card card-body">
                <div className="card-icon">
                  <img
                    src={`${process.env.PUBLIC_URL}/img/file-manager/branding-kit.png`}
                    style={{ width: "100px" }}
                  />
                </div>
                <h5 className="card-title mb-2">{t("branding_kit")}</h5>
                <p className="card-text" style={{ height: "60px" }}>
                  {t("branding_kit_description")}
                </p>
                <Link
                  to="/admin/branding-kit"
                  className="btn btn-primary btn-blink"
                >
                  {t("view_brand_kit")}
                </Link>
              </div>
            </div>

            <div className="col-md-3 mainbox">
              <div className="card card-body">
                <div className="card-icon">
                  <img
                    src={`${process.env.PUBLIC_URL}/img/file-manager/calendar.jpg`}
                    style={{ width: "100px" }}
                  />
                </div>
                <h5 className="card-title mb-2">{t("game_calendar")}</h5>
                <p className="card-text" style={{ height: "60px" }}>
                  {t("game_calendar_description")}
                </p>
                <Link
                  to="/admin/game-calendar"
                  className="btn btn-primary btn-blink"
                >
                  {t("open_calendar")}
                </Link>
              </div>
            </div>
          </div>
        )}

        <div className="row">
          <div className="col-md-12">
            <h4>{t('event_timeline')}</h4>
            <Timeline />
          </div>
        </div>

        <div className="row">
          <div className="col-md-12 d-flex">
            <div className="card flex-fill">
              <div className="card-header">
                <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                  <h6 className="mb-0">Registration Date Wise</h6>
                </div>
              </div>
              <div className="card-body py-0">
                <RegistrationDataChart dailyData={dailyRegistrationData} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
